import React from 'react'
import './styles.css'


const FilterAsideHotels = ({widthContain, position,setFirstRange, setSecondRange, activeFilterPrice ,setActiveFilterPrice, errorFilter,setResetResult,resetResult}) => {
  return (
    <div className='contain-filter-aside-hotels' style={{width:`${widthContain}`, position:`${position}`}}>
         <section className="container-filter-price">
              <h3>
                Precios
              </h3>
              <div className='input-filtrado-price'>
                <div>
                  <label htmlFor="">Desde</label>
                  <input onChange={(e) => {setFirstRange(e.target.value)  }} type="number" />
                </div>
                <div>
                  <label htmlFor="">Hasta</label>
                  <input onChange={(e) => {setSecondRange(e.target.value)  }} type="number" />
                </div>
                 {
                  errorFilter === '' ?
                    ''
                    :
                    <div className='error-form top-m'>
                      <p>{errorFilter}</p>
                    </div>

                } 
                <div className='aplicar-filtro'>
                  <button onClick={() => {
                    setActiveFilterPrice(!activeFilterPrice) }}>
                      Aplicar
                  </button>
                  <button onClick={() => {
                      setResetResult(!resetResult) }}>
                      Resetear
                 </button>
                </div>
              </div>

            </section>
    </div>
  )
}

export default FilterAsideHotels